import { render, staticRenderFns } from "./PlanCardNew.vue?vue&type=template&id=456ae047&scoped=true&"
import script from "./PlanCardNew.vue?vue&type=script&lang=js&"
export * from "./PlanCardNew.vue?vue&type=script&lang=js&"
import style0 from "./PlanCardNew.vue?vue&type=style&index=0&id=456ae047&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456ae047",
  null
  
)

export default component.exports